/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.18.0
 */

import styled from 'styled-components';

import { colors } from '../../../../theme';

export const FormFieldWeekStyled = styled.div.attrs({
    className: 'form-field-week',
})`
    display: flex;
    width: fit-content;
    border: 1px solid ${colors.borderColorSeparate};

    > * {
        cursor: pointer;
        padding: 8px 16px;

        &:not(:last-child) {
            border-right: 1px solid ${colors.borderColorSeparate};
        }

        &:hover {
            background-color: ${colors.backgroundColorHoverOpacity};
        }

        &.selected {
            color: ${colors.textColorWhite};
            background-color: ${colors.backgroundColorSuccess};
        }
    }
`;
